import clsx from "clsx";

interface SwitchProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** "primary" = brand purple (default). "neutral" = monochrome black/white
   *  for places where the brand color clashes (e.g. data dashboards). */
  variant?: "primary" | "neutral";
}

export function Switch({ checked, onChange, variant = "primary" }: SwitchProps) {
  // Track + thumb color tokens, picked at the call site so the rest of the
  // structure (sizing, focus ring, transition) stays identical.
  const trackBg =
    variant === "neutral"
      ? "bg-white border-[#D4D4D8]"
      : "bg-[#F6F5FF] border-[#CBC8FF] dark:border-[#CBC8FF] dark:bg-[#F6F5FF]";
  const thumbBg =
    variant === "neutral"
      ? "after:bg-[#18181B] after:border-[#D4D4D8]"
      : "after:bg-primary after:border-[#CBC8FF]";
  const checkedTrackBg =
    variant === "neutral"
      ? "peer-checked:bg-white"
      : "peer-checked:bg-[#F6F5FF]";

  return (
    <label className="flex items-center cursor-pointer">
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={checked}
        onChange={onChange}
      />
      <div
        className={clsx(
          "relative w-11 h-6 border rounded-full peer peer-focus:ring-[1px] peer-focus:ring-primary/50 dark:peer-focus:ring-primary",
          "peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white",
          "after:content-[''] after:absolute after:top-[1px] after:start-[1px] after:border after:rounded-full after:h-5 after:w-5 after:transition-all",
          trackBg,
          thumbBg,
          checkedTrackBg,
        )}
      ></div>
    </label>
  );
}
